import * as ACTION_TYPES from "../actions/action-types";

const initialState = {
  showUserProfileSidebar: false,
  expanded: [],
  focusedElement: null,
};

/**
 * UserProfileSidebar reducer
 * Manages the visibility, expanded state and focused element for UserProfileSidebar
 * @param {Object} state - Current state
 * @param {Object} action - Action object
 * @returns {Object} New state
 */
const userProfileSidebar = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.TOGGLE_USER_PROFILE_SIDEBAR:
      return {
        ...state,
        showUserProfileSidebar: payload.showUserProfileSidebar,
      };
    case ACTION_TYPES.SET_USER_PROFILE_SIDEBAR_EXPANDED:
      return {
        ...state,
        expanded: payload,
      };
    case ACTION_TYPES.SET_USER_PROFILE_SIDEBAR_FOCUSED_ELEMENT:
      return {
        ...state,
        focusedElement: payload,
      };
    default:
      return state;
  }
};

export default userProfileSidebar;

